import { showGlobalLoading, hideGlobalLoading } from '../actions/deploy-update';
import { showAlert } from './global-alert';
import {
  Purchases,
  PurchasesOfferings,
  LOG_LEVEL,
  CustomerInfo,
} from '@revenuecat/purchases-capacitor';

export async function configureRevenueCat(uid: string) {
  try{
  await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG }); // Enable to get debug logs
  await Purchases.configure({
    apiKey: 'KjAbYOONYmnpMqdAqQGUZREmazXElGTV',
    appUserID: uid, // Optional
  });
} catch(err) {
  console.error(err)
}
}

export async function getRevenueCatOfferings(): Promise<PurchasesOfferings> {
  try {
    const offerings = await Purchases.getOfferings();
    if (
      offerings.current !== null &&
      offerings.current.availablePackages?.length !== 0
    ) {
      // Display packages for sale
      return offerings;
    }
  } catch (error) {
    throw error;
    // Handle error
  }
  throw new Error('no products');
}

export async function purchaseProduct(purchase_id: string) {
  await showGlobalLoading({});
  const offerings = await getRevenueCatOfferings();
  const packageToBuy = offerings.current?.availablePackages?.find(
    (product) => product.product?.identifier === purchase_id,
  );
  try {
    const purchaseResult = await Purchases.purchasePackage({
      aPackage: packageToBuy,
    });
    if (
      typeof purchaseResult.customerInfo.entitlements.active['premium'] !==
      'undefined'
    ) {
      hideGlobalLoading();
      return purchaseResult;
    }
    throw new Error('Purchase failed!');
  } catch (err: any) {
    hideGlobalLoading();
    const message = err?.error?.message ? err.error.message : `${err}`;
    showAlert(message);
  }
}

export async function restoreNativePurchases(): Promise<CustomerInfo> {
  await showGlobalLoading({});
  try {
    const { customerInfo } = await Purchases.restorePurchases();
    hideGlobalLoading();
    return customerInfo;
  } catch (err) {
    console.error(err);
    hideGlobalLoading();
    throw err;
  }
}
